import { Spinner } from "./Brand";

const VARIANTS = {
  primary: "bg-t-brand text-t-onbrand hover:brightness-105 shadow-[0_8px_24px_-12px_var(--brand)]",
  secondary: "bg-t-brand2 text-t-onbrand2 hover:brightness-[0.98]",
  ghost: "bg-transparent text-t-brand hover:bg-t-brand3",
  outline: "bg-t-surface text-t-on border border-t-border hover:bg-t-surface2",
};
const SIZES = { md: "h-11 px-5 text-[15px]", lg: "h-14 px-6 text-base", xl: "h-[60px] px-7 text-[17px]" };

export function Btn({ label, children, onClick, variant = "primary", size = "lg", loading, disabled, icon, className = "", style, testId, type = "button" }) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      data-testid={testId}
      style={style}
      className={`inline-flex items-center justify-center gap-2 rounded-full font-semibold select-none transition-[transform,filter,background-color,opacity] duration-200 active:scale-[0.98] disabled:opacity-50 disabled:pointer-events-none ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
    >
      {loading ? <Spinner /> : icon}
      {label ?? children}
    </button>
  );
}
